module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670627af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 314
// module chunks = 27